import React, { useState, useCallback } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { clearQuizState } from '../../data/quizStorage';

const getBackendBase = () => (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

const QuizEmailCapture = ({ result, traderSegment, answers, onRetake }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setErrMsg('');
      const base = getBackendBase();
      if (!base) {
        setErrMsg("We couldn't save your report from this environment. Try again from the live site or contact support.");
        return;
      }
      setLoading(true);
      let navigated = false;
      try {
        const res = await fetch(`${base}/trader-quiz/submissions`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email.trim(),
            traderSegment: traderSegment || null,
            result,
            answers: answers || {},
          }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          throw new Error(data.error || 'Request failed');
        }
        const path = data.resultsPath;
        if (typeof path === 'string' && path.startsWith('/')) {
          clearQuizState();
          navigated = true;
          navigate(path, { replace: true });
          return;
        }
        setErrMsg('Your report was saved but we could not open the link. Check your email for the results link.');
      } catch (err) {
        setErrMsg(err.message || 'Something went wrong. Try again.');
      } finally {
        if (!navigated) {
          setLoading(false);
        }
      }
    },
    [email, traderSegment, result, answers, navigate],
  );

  return (
    <section className="quiz-results-panel quiz-results-panel-tools quiz-email-capture mt-2 mb-2 text-center">
      <p className="quiz-email-capture-done text-light fw-semibold mb-0">You&apos;re done!</p>
      <h3 className="quiz-section-heading quiz-section-heading--tools h5 mb-2">Email my results</h3>
      <p className="small text-muted mb-3">
        We&apos;ll send you a link to this report. It&apos;s free—no charge.
      </p>

      {errMsg ? (
        <Alert variant="danger" className="py-2 small mb-3 text-start">
          {errMsg}
        </Alert>
      ) : null}

      <div className="quiz-email-capture-actions">
        <Form onSubmit={onSubmit} className="quiz-email-capture-form">
          <Form.Group className="mb-3" controlId="quiz-result-email">
            <Form.Label className="visually-hidden">Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              autoComplete="email"
              required
              placeholder="you@example.com"
              value={email}
              onChange={(ev) => setEmail(ev.target.value)}
              disabled={loading}
              className="bg-dark border-secondary text-light"
            />
          </Form.Group>
          <Button type="submit" variant="primary" disabled={loading} className="quiz-cta-btn quiz-email-capture-submit">
            {loading ? 'Sending…' : 'Send me the link'}
          </Button>
        </Form>
      </div>

      {onRetake ? (
        <div className="mt-3">
          <button type="button" className="btn btn-link btn-sm quiz-inline-nav-btn p-0" onClick={onRetake}>
            Start over
          </button>
        </div>
      ) : null}

      <p className="small text-muted mt-3 mb-0">
        <Link to="/quiz/profiles">Trader archetypes overview</Link>
      </p>
    </section>
  );
};

export default QuizEmailCapture;
